import * as CryptoJS from "crypto-js";

import moment from "moment";

export const DataEncription = (data) => {
    console.log(data, "payload")
    let initiateTime = moment().valueOf();
    data["initateTime_pfbZDUvFueex"] = initiateTime;
    var ciphertext = CryptoJS.AES.encrypt(JSON.stringify(data), process.env.REACT_APP_AES_SECRET).toString();
    let res = { encryptedData: ciphertext };
    return res;
};

export const Decrypt = (ciphertext)=> {


    var bytes = CryptoJS.AES.decrypt(ciphertext, process.env.REACT_APP_AES_SECRET);
    var decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    return decryptedData;
}

export const makeid = (length) => {
    var result = ''
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
    var charactersLength = characters.length
    for (var i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength))
    }
    return result + moment().valueOf()
};
